import { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash';

export class BaseRendererComponent {
  public params: ICellRendererParams = null;

  public getMoreRowInfo(params: ICellRendererParams = this.params) {
    const field: string = get(params, 'column.colDef.field', '');
    const rowIndex: number = get(params, 'node.rowIndex', 0);
    const rowId: string = get(params, 'node.id', null);
    const rowData: object = get(params, 'node.data');

    return {
      field,
      rowIndex,
      rowId,
      rowData,
    };
  }
}
